import { create } from 'zustand';

/**
 * Tracks the last time the player gave a "here" signal — bumped by:
 *   1. Outbound WS sends via `gameConnectionManager.sendAction` and the
 *      `websocketService.send{Chat,Tavian}Message` family (text submit,
 *      action card click, slash command, target picker).
 *   2. Typing in the chat composer (`ChatComposer`'s `onChange`).
 *
 * Drives the AFK timer in `LobbyLayout` and `GameLayout`.
 *
 * Why this, not DOM events: NPC narration auto-scrolls the chat panel which
 * fires `mousemove` / `scroll`-style activity even when the player is AFK
 * (#284 was the regression that motivated moving off DOM events). The two
 * narrow sources above are both unambiguous "player is here" signals — NPC
 * narration scrolls the chat panel but does NOT dispatch `onChange` on the
 * player's input element, and the WS-send signal is intent-derived. Pre-fix
 * the typing signal was missing: long NPC narration sequences could fire the
 * AFK kick mid-sentence even while the player was actively typing a draft
 * (scenario 2026-05-12 B9).
 */
interface PlayerActivityState {
  lastPlayerIntentAt: number;
  markPlayerIntent: () => void;
}

export const usePlayerActivityStore = create<PlayerActivityState>((set) => ({
  lastPlayerIntentAt: Date.now(),
  markPlayerIntent: () => set({ lastPlayerIntentAt: Date.now() }),
}));
